import { useTranslation } from 'react-i18next'

import {
  CategoryMultiSelect,
  CategorySelectFormikField,
} from '../../../../Category'
import { FieldStackedLabel } from '../../../../Field'
import { getMappingRowCategoriesName } from '../EditBuildingAndCategoryModalFormFields.utils'

import * as styles from '../EditBuildingAndCategoryModalFormFields.module.css'

function CategoryField({ index, isLoading, isSubmitting }) {
  const { t } = useTranslation()

  return (
    <div className={styles.column}>
      <CategorySelectFormikField
        multi
        Field={FieldStackedLabel}
        Select={CategoryMultiSelect}
        controlProps={{
          contentProps: {
            inputProps: {
              autoFocus: index === 0,
              placeholder: t('Provider.FormCategoryFieldPlaceholderKey'),
            },
          },
        }}
        disabled={isSubmitting}
        fieldComponentProps={{
          isLoading,
          label: t('Provider.FormCategoryFieldLabelKey'),
        }}
        name={getMappingRowCategoriesName(index)}
      />
    </div>
  )
}

export default CategoryField
